import React from 'react';

import Messenger from './messenger/Messenger';
import ProgressBar from './progress-bar/ProgressBar';

class Body extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: props.isMobile,
      avatar_shape: props.avatar_shape,
      keywords: props.keywords,
      logo: props.logo,
      branding: props.branding,
      tagline: props.tagline,
    };
    this.ee = props.ee;
  }

  render() {
    const ee = this.ee;
    const { 
      isMobile,
      avatar_shape,
      logo,
      brand_name,
      tagline,
      keywords,
      progress,
      branding,
      typing,
      widget_hide_header,
    } = this.props;
    
    return (
      <section id="hu-body">
        <ProgressBar progress={progress}/>
        <Messenger
          isMobile={isMobile}
          avatar_shape={avatar_shape}
          logo={logo}
          brand_name={brand_name}
          tagline={tagline}
          keywords={keywords}
          branding={branding}
          typing={typing}
          widget_hide_header={widget_hide_header}
          ee={ee}
        />
      </section>
    )
  }
}

export default Body;


// WEBPACK FOOTER //
// ./app/js/components/Body.js